































































































































































































































































































































































































































// @ts-nocheck
import Vue from 'vue'
import { differenceInMinutes, parse } from 'date-fns';
import { format } from 'date-fns';
import MarkdownItVue from 'markdown-it-vue';
import _, { padStart } from 'lodash';
import axios from 'axios';

export default Vue.extend({
    components: {
        MarkdownItVue,
    },
    props: [
        'entry',
        'client',
        'previousInvoices',
        'previousProjects',
        'users',
        'isAdmin',
        'clients',
        'isSingle'
        // 'projects'
    ],
    data() {
        return {
            hourOptions: _.range(1, 13),
            minuteOptions: _.range(0, 50, 15),
            projects: [] as any[],
            localClients: [] as any[],
            localUsers: [] as any[],
            form: {
                start_date: new Date(),
                end_date: new Date(),
                start_time: new Date(),
                end_time: null,
                work_type_id: 0,
                client_id: null,
                billed_at: null as null | Date,
                billed_date: null,
                billable: true,
                invoice_number: null,
                employee_id: parseInt(this.$store.state.account.id, 10),
                start_hour: (new Date()).getHours(),
                start_minutes: (new Date()).getMinutes(),
                start_time_hour: (new Date()).getHours(),
                start_time_minutes: (new Date()).getMinutes(),
                start_time_meridian: 'AM',
                end_time_meridian: 'AM',
                project: null
            } as any,
            isEdit: !!this.entry,
            isStartDateModalOpen: false,
            isStartTimeModalOpen: false,
            isEndDateModalOpen: false,
            isBilledAtModalOpen: false,
            isEndTimeModalOpen: false,
            editorTab: 0,
            markdownOptions: {
                markdownIt: {
                    linkify: true
                },
                linkAttributes: {
                    attrs: {
                    target: '_blank',
                    rel: 'noopener'
                    }
                }
            },
            hours: _.range(1, 13),
            minutes: _.range(0, 60, 15)
        }
    },
    watch: {
        'form.client_id': function(newVal: any) {
            if (newVal && newVal !== 0) {
                this.getProjects(newVal);
            } else {
                this.projects = [];
            }
        },
    },
    mounted() {
        let override = false;

        if (localStorage.getItem('timeEntryForm')) {
            const ok = confirm("You have a time entry form saved. Do you want to load it?");
            if (ok) {
                this.form = JSON.parse(localStorage.getItem('timeEntryForm') || '');
                override = true;
            } else {
                localStorage.removeItem('timeEntryForm');
            }
        }
        
        if (this.isEdit) {
            this.form = Object.assign(this.form, this.entry);

            this.form.start_date = format(this.form.started_at, 'YYYY-MM-DD');
            this.form.start_time = format(this.form.started_at,'hh:mm');
            this.form.start_time_hour = Number(format(this.form.started_at,'hh'));
            this.form.start_time_minutes = Number(format(this.form.started_at,'mm'));
            this.form.start_time_meridian = format(this.form.started_at,'a').toUpperCase();

            this.form.start_time_minutes = this.fixMinutes(this.form.start_time_minutes);

            this.form.end_date = '';

            if (this.form.ended_at) {
                this.form.end_date = format(this.form.ended_at, 'YYYY-MM-DD');
                this.form.end_time = format(this.form.ended_at,'hh:mm');
                this.form.end_time_hour = Number(format(this.form.ended_at,'hh'));
                this.form.end_time_minutes = Number(format(this.form.ended_at,'mm'));
                this.form.end_time_meridian = format(this.form.ended_at,'a').toUpperCase();

                for (const step of this.minuteOptions) {
                if (step >= this.form.start_time_minutes) {
                    this.form.start_time_minutes = step;
                    break;
                }
            }
            }

            if (this.form.billed_at) {
                this.form.billed_date = format(this.form.billed_at, 'YYYY-MM-DD');
            }
        } else {
            if (!override) {
                this.resetForm();
            }
            // const coeff = 1000 * 60 * 15;
            // this.form.start_time = new Date(Math.round(this.form.start_time.getTime() / coeff) * coeff);
        }

        if (this.client) {
            this.form.client_id = this.client.id;
        }

        this.localClients = this.clients;

        if (this.isSingle) {
            if (this.form.client_id && (!this.localClients || this.localClients.length === 0)) {
                this.getClient(this.form.client_id);
            }

            this.form.project = this.entry.project;

            this.getUser(this.entry.employee_id);
            this.getActivity(this.entry.work_type_id);
        }
    },
    methods: {
        async getActivity(activityId: number) {
            try {
                const result = await axios.get(`/work_types/${activityId}`);
                this.form.work_type_id = result.data;
            } catch (e) {
                console.error(e);
            }
        },
        async getClient(clientId: number) {
            try {
                const result = await axios.get(`/clients/${clientId}`);
                this.localClients = [result.data];
            } catch (e) {
                console.error(e);
            }
        },
        async getUser(userId: number) {
            try {
                const result = await axios.get(`/users/${userId}`);
                this.localUsers = [result.data];
                console.log("User", result.data);
            } catch (e) {
                console.error(e);
            }
        },
        displayProjectItem(item: any) {
            return item.name;
        },
        setEndDate(date: Date | string) {
            if (typeof date === 'string') {
                this.form.end_date = date;
            } else {
                this.form.end_date = format(date, 'YYYY-MM-DD');
            }
        },
        resetEndDate() {
            this.form.end_date = null;
            this.form.end_time = null;
            this.form.end_time_hour = null;
            this.form.end_time_minutes = null;
        },
        toggleStartTimeMeridian() {
            this.form.start_time_meridian = this.form.start_time_meridian === 'PM' ? 'AM' : 'PM';
        },
        toggleEndTimeMeridian() {
            this.form.end_time_meridian = this.form.end_time_meridian === 'PM' ? 'AM' : 'PM';
        },
        updateStartTimeHours(value: any) {
            const startTime = this.form.start_time.split(':');
            const minutes = startTime[1] || '';
            this.form.start_time = value + ':' + minutes;
            this.form.start_time_hour = value;

            Vue.set(this.form, 'start_time_hour', value)
        },
        updateStartTimeMinutes(value: any) {
            const startTime = this.form.start_time.split(':');
            const hours = startTime[0] || '0';
            this.form.start_time = hours + ':' + value
        },
        updateEndTimeHours(value: any) {
            const startTime = (this.form.end_time && this.form.end_time.split(':')) || [0,0];
            const minutes = startTime[1] || '';
            this.form.end_time = value + ':' + minutes;
            this.form.end_time_hour = Number(value);
        },
        updateEndTimeMinutes(value: any) {
            const startTime = (this.form.end_time && this.form.end_time.split(':')) || [0,0];
            const hours = startTime[0] || '';
            this.form.end_time = hours + ':' + value;
            this.form.end_time_minutes = Number(value);
        },
        updateFormInvoice(invoice: string) {
            this.form.invoice_number = invoice;
        },
        updateFormProject(project: string) {
            this.form.project = project;
        },
        setTodayInvoiceDate() {
            this.form.billed_at = new Date();
            this.form.billed_date = format(this.form.billed_at, 'YYYY-MM-DD')
        },
        updateBilledDate(value: Date | null) {
            if (value) {
                this.form.billed_date = value;
            }

            this.isBilledAtModalOpen = false;
        },
        updateStartDate(value: Date | null) {
            if (value) {
                this.form.start_date = value;
            }

            this.isStartDateModalOpen = false;
            
        },
        updateEndDate(value: Date | null) {
            if (value) {
                this.form.end_date = value;
            }

            this.isEndDateModalOpen = false;
        },
        clearInvoiceDate() {
            this.form.billed_at = null;
            this.form.billed_date = null;
        },
        toggleBilledAt(checked: boolean) {
            if (!checked) {
                this.clearInvoiceDate();
            } else {
                this.form.billed_at = new Date();
                this.form.billed_date = format(this.form.billed_at, 'YYYY-MM-DD')
            }
        },
        fixMinutes(minutes: number) {
            for (const step of this.minuteOptions) {
                if (step >= minutes) {
                    return step;
                }
            }
        },
        updateProject(data: any) {
            this.form.project = this.projects.find((x: any) => x.id === data)?.name;
        },
        resetForm() {
            const now = new Date();

            this.form = {
                start_date: format(now, 'YYYY-MM-DD'),
                end_date: format(now, 'YYYY-MM-DD'),
                start_hour: (new Date()).getHours(),
                start_minutes: (new Date()).getMinutes(),
                end_time: null,
                project: null,
                invoice_number: null,
                notes: '',
                billable: true,
                billed_at: null,
                work_type_id: this.workTypes[0] && this.workTypes[0].id,
                client_id: 0,
                employee_id: parseInt(this.$store.state.account.id, 10),
                end_time_hour: null,
                end_time_minutes: null,
                end_time_meridian: format(now,'a').toUpperCase(),
                start_time_hour: Number(format(now, 'hh')),
                start_time_minutes: this.fixMinutes(Number(format(now, 'mm'))),
                start_time_meridian: format(now,'a').toUpperCase()
            };

            this.form.start_time = this.form.start_time_hour + ':' + this.form.start_time_minutes;

            if (this.client) {
                this.form.client_id = this.client.id;
            }
        },
        async getProjects(clientId: number) {
            try {
                const result = await axios.get(`/projects?client_id=${clientId}`);
                this.projects = _.orderBy(result.data, ['name'], ['asc']);
            } catch (e) {
                console.error(e);
            }
        },
        save(event: any, isClose = false) {
            try {
                // set current form to save locally to prevent 401 errors and to retry
                // TODO: handle how to reload
                localStorage.setItem('timeEntryForm', JSON.stringify(this.form));

                if (!this.form.project) {
                    alert("Please select a project");
                    return;
                }

                if (!this.form.client_id) {
                    alert("Please select a client");
                    return;
                }

                // prevent submitting if end time is set but missing end date
                if (this.form.end_time && !this.form.end_date) {
                    alert("Please select an end date");
                    return;
                }

                // prevent submitting if end date set but missing end time
                if (this.form.end_date && !this.form.end_time) {
                    alert("Please select an end time");
                    return;
                }

                const data = Object.assign({}, this.form);

                if (!this.isEdit) {
                    delete data.id;
                }

                if (data.start_time_hour === 12) {
                    if (data.start_time_meridian === 'AM') {
                        data.start_time_hour = 0;
                    }
                } else if (data.start_time_meridian === 'PM') {
                    data.start_time_hour += 12;
                }

                data.start_time = padStart(data.start_time_hour, 2, '0') + ':' + padStart(data.start_time_minutes, 2, '0');

                const formattedDate = `${data.start_date} ${data.start_time}`;
                data.started_at = parse(`${data.start_date} ${data.start_time}`);
                data.ended_at = null;
                
                if (data.end_time && data.end_date) {
                    if (data.end_date.getFullYear) {
                        data.end_date = format(data.end_date, 'YYYY-MM-DD')
                    }

                    if (data.end_time_hour === 12) {
                        if (data.end_time_meridian === 'AM') {
                            data.end_time_hour = 0;
                        }
                    } else if (data.end_time_meridian === 'PM') {
                        data.end_time_hour += 12;
                    }

                    data.end_time = padStart(data.end_time_hour, 2, '0') + ':' + padStart(data.end_time_minutes, 2, '0');

                    data.ended_at = parse(`${data.end_date} ${data.end_time}`);
                }
                
                if (data.billed_date) {
                    data.billed_at = parse(`${data.billed_date}`);
                }

                // prevent negative time entries
                if (data.ended_at && this.calculatedTime <= 0) {
                    alert("End time must be greater than start time");
                    return;
                }
                
                this.$emit('save', { isEdit: this.isEdit, timeEntry: data });
                this.resetForm();
                this.close();


                localStorage.removeItem('timeEntryForm');
            } catch (e) {
                console.error(e);
                alert("An error occurred while saving the time entry");
                this.$emit('error', e);
            }
        },
        close() {
            this.$emit('close');
            this.resetForm();
        }
    },
    computed: {
        activeUsers() {
            if (!this.localUsers || this.localUsers.length === 0) {
                return [];
            }

            return this.localUsers.filter(x => !x.deleted_at);
        },
        allowedMinutes(): any[] {
            return [
                0,
                15,
                30,
                45
            ]
        },
        calculatedTimeClasses(): string[] {
            return [
                this.calculatedTime <= 0 ? 'is-error' : ''
            ]
        },
        calculatedTime(): number {
            if (!this.form.start_date
                || !this.form.end_date
                || !this.form.start_time
                || !this.form.end_time) {
                return 0;
            }
            
            const start = new Date(this.form.start_date);
            const end = new Date(this.form.end_date);

            const startTime = this.form.start_time.split(':');
            const endTime = this.form.end_time.split(':');

            let startHour = +startTime[0];
            const startMinutes = +startTime[1];

            if (startHour === 12) {
                if (this.form.start_time_meridian === 'AM') {
                    startHour = 0;
                }
            } else if (this.form.start_time_meridian === 'PM') {
                startHour += 12;
            }

// 12am = 0
// 1am = 1
// 11am = 11
// 12pm = 12
// 1pm = 13
            let endHour = +endTime[0];
            const endMinutes = +endTime[1];

            if (endHour === 12) {
                if (this.form.end_time_meridian === 'AM') {
                    endHour = 0;
                }
            } else if (this.form.end_time_meridian === 'PM') {
                endHour += 12;
            }

            start.setHours(startHour);
            start.setMinutes(startMinutes);
            end.setHours(endHour);
            end.setMinutes(endMinutes);

            const minutes = Math.ceil((differenceInMinutes(end, start) / 60) * 100);

            return minutes / 100;
        },
        workTypes(): Client[] {
            return this.$store.state.workTypes;
        },
        // clients(): Client[] {
        //     return this.$store.state.clients;
        // },
        submitText(): string {
            return this.isEdit ? 'Save' : 'Create';
        },
        actionText(): string {
            return this.isEdit ? 'Update' : 'Create';
        }
    }
})
